import { Moment } from "moment";
import { IAccrualType } from "./court/IAccrualType";
import { ICourt } from "./court/ICourt";
import { ICourtType } from "./court/ICourtType";

export interface IPrecatorio {
  id?: number;
  status?: PrecatorioStatus;
  court?: ICourt;
  civilCourt?: string;
  processCode?: string;
  processCodeSource?: string;
  cpfCnpj: string;
  requered?: string;
  nature?: string;
  baseDate?: string;
  issueDate?: string;
  principal?: number;
  interest?: number;
  source?: string;
  reportingJugde?: string;
  requester?: string;
  situation?: string;
  urlProcess?: string;
  urlProcessFile?: string;
  user?: IUser;
  requerente?: string;
  isTrusted?: boolean;
  classification?: PrecatorioClassification;
  createdDate?: Date;
  isPss?: boolean;
  comission?: number;
  active?: boolean;
  state?: string;
  city?: string;
  totalAmountRequisition?: number;
  typeProcessIdentifier?: string;
  precatorioTypeIdentifierype?: string;
  pssValue?: number;
  pssBaseDate?: string;
  natureIdentifier?: string;
  provisionPaymentDate?: string;
  subject?: string;
  type?: ICourtType;
  correctionType?: IAccrualType;
  birthDate?: Moment;
}

export interface IApplicant {
  id?: number;
  email?: string;
  fullName: string;
  birthDate: string;
  phoneNumber?: string;
  cpfCnpj: string;
  precatorios: IPrecatorio[];
}

export interface IUser {
  id?: number;
  login: string;
  fullName?: string;
  birthDate?: Moment;
  phoneNumber: string;
  cpfCnpj: string;
  type?: UserType;
  active?: boolean;
  isSendMail?: boolean;
}

export enum PrecatorioType {
  Federal = "Federal",
  Estadual = "Estadual",
  Municipal = "Municipal",
  Indefinido = "Indefinido"
}

export type IPrecatorioApplicantLink = "Undefined" | "Owner" | "Heir" | "Inventorian";

export enum PrecatorioStatus {
  Pendente = "Pendente",
  Precificando = "Precificando",
  Precificado = "Precificado"
}
export enum PortalOrigin {
  CLIENTE = "CLIENTE",
  MIGALHAS = "MIGALHAS"
}

export interface ILegalProcess {
  id?: number;
  court?: string;
  processCode?: string;
  processCodeSource?: string;
  cpfCnpj: string;
  requered?: string;
  nature?: string;
  baseDate?: string;
  issueDate?: string;
  amount?: number;
  interest?: number;
  source?: string;
  reportingJugde?: string;
  requester?: string;
  situation?: string;
  urlProcess?: string;
  type: PrecatorioType;
}

export interface IOperationCost {
  accrual: string;
  acquisitionVal: string;
  comission: string;
  cost: string;
  disbursementCost: string;
  dtExpiry: string;
  dtStart: string;
  finalPrice: string;
  id: number;
  operationCost: string;
  pss: string;
  registryCost: string;
  settlementCostValue: string;
  totalExpenses: string;
  uniproof: string;
}

export class OperationCost {
  public id?: number;
  public scriptureCosts?: number;
  public uniproof?: number;
  public attorneyCost?: number;
  public lawyerDisbursementCost?: number;
  public othersCosts?: number;
  public commission?: number;
  public lawyerSettlementCost?: number;
  public totalExpenses?: number;
  public dtDisbursement?: Date;
  public dtMaturity?: Date;
  public totalDisbursementCost?: number;
  public totalSettlementCostValue?: number;
  public finalPrice?: number;
  public totalPrecatorioCost?: number;
  public cost?: number;
  constructor(
    id,
    scriptureCosts,
    uniproof,
    attorneyCost,
    lawyerDisbursementCost,
    othersCosts,
    commission,
    lawyerSettlementCost,
    totalExpenses,
    dtDisbursement,
    dtMaturity,
    totalDisbursementCost,
    totalSettlementCostValue,
    finalPrice,
    totalPrecatorioCost,
    cost
  ) {
    this.id = id;
    this.scriptureCosts = scriptureCosts;
    this.uniproof = uniproof;
    this.attorneyCost = attorneyCost;
    this.lawyerDisbursementCost = lawyerDisbursementCost;
    this.othersCosts = othersCosts;
    this.commission = commission;
    this.lawyerSettlementCost = lawyerSettlementCost;
    this.totalExpenses = totalExpenses;
    this.dtDisbursement = dtDisbursement;
    this.dtMaturity = dtMaturity;
    this.totalDisbursementCost = totalDisbursementCost;
    this.totalSettlementCostValue = totalSettlementCostValue;
    this.finalPrice = finalPrice;
    this.totalPrecatorioCost = totalPrecatorioCost;
    this.cost = cost;
  }
}

export interface ICertificates {
  id: number;
  file: string;
  category: string;
  fileName: string;
  path: string;
  description: string;
  uploadDate: string;
  storageType: string;
}
export interface IDocument {
  id: number;
  file: string;
  category: string | DocumentCategory;
  fileName: string;
  path: string;
  description: string;
  uploadDate: string;
  storageType: string;
  tradeID: number;
}

export interface IDocumentMinify {
  id: number;
  file: string;
  category: string | DocumentCategory;
  fileName: string;
  tradeID: number;
}

export enum DocumentCategory {
  ID_USER,
  ID_OWNER,
  ID_SPOUSE,
  SELFIE_OWNER,
  DEATH_CERTIFICATE,
  INVENTORY,
  DILIGENCE,
  LAWYER_ATTACHMENT,
  OFFICER_ACCEPTENCE_CONTRACT,
  OFFICER_CESSION_CONTRACT,
  ADMIN_CESSION_CONTRACT,
  OFFICER_INVOICE,
  MARRIAGE_CERTIFICATE,
  LETTER_OF_ATTORNEY,
  TED_RECEIPT,
  // CLICK_SIGN_CONTRACT,
  RESIDENTIAL_CERTIFICATE,
  PUBLIC_DEED,
  LEGAL_PROCESS,
  COMPLIANCE,
  TICKET,
  CLICK_SIGN_CONTRACT_ACCEPTENCE_TERM,
  CLICK_SIGN_CONTRACT_CESSION_TERM,
  CLICK_SIGN_CONTRACT_OLD_CESSION_TERM,
  ADMIN_ACCEPTENCE_CONTRACT
}

export enum StorageType {
  S3,
  Link
}

export type ITradeType = "Undefined" | "OnLine" | "OffLine";

export enum TradeAccountType {
  Corrente = "Corrente",
  Poupanca = "Poupanca"
}

export enum TradeStatus {
  Undefined = 0,
  Aberto = "Aberto",
  Rejeitado = "Rejeitado",
  Aprovado = "Aprovado",
  Manual = "Manual",
  Negociando = "Negociando"
}

export enum TradePhase {
  Undefined = "Undefined",
  SellChoice = "SellChoice",
  Created = "Created",
  ContractInformation = "ContractInformation",
  BankInfo = "BankInfo",
  DocumentValidation = "DocumentValidation",
  DocumentApproval = "DocumentApproval",
  LegalCertificates = "LegalCertificates",
  ContractSignatureAcceptenceTerm = "ContractSignatureAcceptenceTerm",
  Fraud = "Fraud",
  PreFraud = "PreFraud",
  Compliance = "Compliance",
  CreditValidation = "CreditValidation",
  Analysis = "Analysis",
  Diligence = "Diligence",
  SpecialSituation = "SpecialSituation",
  PreCartorio = "PreCartorio",
  ContractSignatureCessionTerm = "ContractSignatureCessionTerm",
  Cartorio = "Cartorio",
  Funding = "Funding",
  Payment = "Payment",
  ContractSignature = "ContractSignature" // Antigo, para controle
}

export interface ITradePhaseTranslation {
  name: string;
  alias: string;
  key: number;
}

export const SelectTradePhaseTranslation: ITradePhaseTranslation[] = [
  {
    name: "SellChoice",
    alias: "Venda Iniciada",
    key: 1
  },
  {
    name: "DocumentValidation",
    alias: "Validação de Documento",
    key: 2
  },
  {
    name: "DocumentApproval",
    alias: "Aprovação de Documento",
    key: 4
  },
  {
    name: "ContractInformation",
    alias: "Informações de Contrato",
    key: 5
  },
  {
    name: "ContractSignature",
    alias: "Assinatura de Contrato",
    key: 6
  },
  {
    name: "LegalCertificates",
    alias: "Certidões Legais",
    key: 7
  },
  {
    name: "Diligence",
    alias: "Diligência",
    key: 8
  },
  {
    name: "SpecialSituation",
    alias: "Aprovação Special",
    key: 9
  },
  {
    name: "PreCartorio",
    alias: "Cartorio",
    key: 10
  },
  {
    name: "Attorney",
    alias: "Procuração",
    key: 11
  },
  {
    name: "Cartorio",
    alias: "Cartório",
    key: 12
  },
  {
    name: "Funding",
    alias: "Payment",
    key: 13
  },
  {
    name: "Payment",
    alias: "Pós-Compra",
    key: 14
  }
];

export enum TradePhaseMonitoring {
  SellChoice = "SellChoice",
  DocumentValidation = "Validação de Documento",
  DocumentApproval = "Aprovação de Documento",
  ContractInformation = "Infor. de Contrato",
  BankInfo = "Dados Bancários",
  ContractSignature = "Ass. de Contrato",
  LegalCertificates = "Envio de Certidões",
  Diligence = "Diligência",
  Payment = "Pagamento"
}

export interface IBackGroundCheck {
  id: number;
  checkSpc: {
    passedSpc: boolean;
    spcTotalValue: number;
    restriction: { code: number; message: string };
    hasRestrictions: boolean;
  };
  checkCpf: {
    passedCpfReceita: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkCNpj: {
    passedCnpjReceita: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkPep: {
    passedPep: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkCertDebtAbsence: {
    passedCertDebtAbsence: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkPGFN: {
    passedPGFN: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkMidia: {
    passedMidia: boolean;
    mediaProfileAndExposure: {
      mediaExposureLevel: string;
      celebrityLevel: string;
      unpopularityLevel: string;
    };
  };
  checkProcessos: {
    passedProcessos: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkLegalRepresentative: {
    passedLegalRepresentative: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  checkCoaf: {
    passedCoaf: boolean;
    restriction: string;
    hasRestrictions: boolean;
  };
  report: string;
  cpfCnpj: string;
  name?: string;
  isApproved: boolean;
  restrictions: string;
  createdDate: string;
  birthDate: string;
}

export enum PropertyRegime {
  Indefinido = "Indefinido",
  ComunhaoParcial = "ComunhaoParcial",
  ComunhaoTotal = "ComunhaoTotal",
  SeparacaoTotal = "SeparacaoTotal"
}

export enum PropertyRegimeDesc {
  Indefinido = "Selecione o regime de bens",
  ComunhaoParcial = "Comunhão Parcial de Bens",
  ComunhaoTotal = "Comunhão Total de Bens",
  SeparacaoTotal = "Separacão Total de Bens"
}

export enum UserType {
  Cliente = "Cliente",
  ClienteMigalhas = "ClienteMigalhas",
  ClientePan = "ClientePan"
}

export enum PrecatorioClassification {
  Precatorio = "Precatorio",
  RPV = "RPV",
  Indefinido = "Indefinido"
}

export enum AccrualTypeEnum {
  SelicLinear = 0,
  Ipca = 1
}

export interface ICalculator {
  request: {
    dataExpedicao: Date;
    dataVencimento: Date;
    dataBase: Date;
    principal: number;
    juros: number;
    spread: number;
    tipoAccrual: AccrualTypeEnum;
    porcentagemDefault: number;
    porcentagemComissao: number;
    custoDesembolso: number;
    mesesParaLiquidacao: number;
    dataDesembolso: Date;
  };
  price: number;
  updateAmount: number;
  futureAmount: number;
}

export interface ICommonDomain {
  id: number;
  code: string;
  name: string;
  jObject: object;
  parentId?: number;
  order: number;
  canonical?: string;
  isActive: boolean;
  children: ICommonDomain[];
}

export interface ICorrectionTableAll {
  id: number;
  tableName: string;
  rows: object;
}

export interface ICommonDomainList {
  value: ICommonDomain[];
  "@odata.nextLink"?: string;
  "@odata.count"?: string;
}

export enum OfficerProfilesAlias {
  Officer_Master = "Gerencial",
  Officer_Administrator = "Administrador",
  Officer_Operator = "Operador"
}

export enum responsibility {
  Owner,
  Spouse,
  lawyer
}

export enum BcheckTypeEnum {
  Compliance,
  Dilligence
}



// WEBPACK FOOTER //
// ./src/services/interfaces/UserInterface.ts